import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { RelativeTime } from "@design-system/RelativeTime/RelativeTime";
import { MemberAccessLogRow } from "../memberAccessLogRow";

export const CreatedAtCell = memo(
    ({ row }: CellContext<ViewTableFeatures, MemberAccessLogRow, unknown>) => (
        <RelativeTime date={row.original.createdAt} />
    ),
);
